module.exports = __webpack_public_path__ + "media/images/lb/138-d95b9075cdef8409f582b91747b5d8b2.svg";